// extracted by mini-css-extract-plugin
module.exports = {"topBar":"MyQr_topBar__2UDzR"};